import { gql } from 'apollo-boost';

export const FOLDER_CHANGED_SINCE = gql`
    query folderChangedSince($folderId: ID!, $since: Date!) {
        folderChangedSince(folderId: $folderId, since: $since)
    }
`;
